import axios from "axios";
import { toast } from "../hooks/use-toast";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("antonio_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Tratamento GLOBAL de erro: nenhuma tela precisa (nem deve) quebrar por erro de API.
// - 401 → sessão morta, volta pro login
// - 402 upgrade_necessario → enriquece o erro (err.upgrade) + evento "api:upgrade";
//   as telas mostram o CTA inline via getUpgradeInfo (sem toast pra não duplicar)
// - 429 → toast "muitas tentativas"
// - 5xx / sem rede → toast "sem conexão"
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const detail = err.response?.data?.detail;
    if (status === 401) {
      localStorage.removeItem("antonio_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    } else if (status === 402 && detail && detail.code === "upgrade_necessario") {
      err.upgrade = { upgrade: true, ...detail };
      try { window.dispatchEvent(new CustomEvent("api:upgrade", { detail })); } catch {}
    } else if (err.config?.silent) {
      // Chamada de fundo (ex.: landing pública com o backend dormindo) — sem toast
    } else if (status === 429) {
      toast({ title: "Muitas tentativas", description: "Espera um pouco e tenta de novo." });
    } else if (!err.response || status >= 500) {
      toast({
        title: "Sem conexão com o servidor",
        description: "Tenta de novo em alguns segundos.",
        variant: "destructive",
      });
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(" ");
  if (detail && typeof detail === "object" && detail.mensagem) return detail.mensagem;
  if (!err?.response) return "Sem conexão com o servidor. Tenta de novo.";
  return err?.message || "Algo deu errado.";
}

// Erro 402 = cadeado de plano. Devolve {upgrade:true, recurso, plano_atual, plano_necessario, mensagem} ou null.
export function getUpgradeInfo(err) {
  if (err?.upgrade) return err.upgrade;
  const detail = err?.response?.data?.detail;
  if (err?.response?.status === 402 && detail && typeof detail === "object") return { upgrade: true, ...detail };
  return null;
}
